import { SweetAlertOptions } from 'sweetalert2';

export const toastConfig = (timer: (number | null) = null): SweetAlertOptions => ({
    toast: true,
    timer: timer || 5000,
    position: 'bottom-end',
    showConfirmButton: false,
});
